// src/features/auth/register/components/PasswordField.jsx

import { MdVisibility, MdVisibilityOff } from "react-icons/md";
import styles from "../Register.module.css";

const PasswordField = ({ label, icon, show, setShow, error, ...props }) => {
  return (
    <div className={styles.field}>
      <label className={styles.label}>{label}</label>

      <div className={styles.inputWrap}>
        <span className={styles.iconLeft}>{icon}</span>

        <input
          type={show ? "text" : "password"}
          className={`${styles.input} ${styles.inputPadRight} ${
            error ? styles.inputError : ""
          }`}
          {...props}
        />

        <button
          type="button"
          className={styles.toggleBtn}
          onClick={() => setShow((v) => !v)}
          aria-label={show ? "Sembunyikan kata sandi" : "Tampilkan kata sandi"}
        >
          {show ? <MdVisibilityOff size={19} /> : <MdVisibility size={19} />}
        </button>
      </div>

      {error && <span className={styles.fieldError}>{error}</span>}
    </div>
  );
};

export default PasswordField;
